export const UrlSearchParamsIe = (searchString) => {
  if (searchString) {
    const query = searchString.substr(1)
    const params = query.split('&').reduce((pairs, token) => {
      const [k, v] = token.split('=')
      return { ...pairs, [k]: v }
    }, {})
    return params
  } else return null
}



// WEBPACK FOOTER //
// ./src/polyfill/UrlSearchParams.js